(function() {
  'use strict';
  angular.module('providerPortal')
  .provider('asyncYamlLoader', function() {
    var url;
    this.url = function(_url) {
      if (_url) {
        url = _url;
      }
      return url;
    };
    this.$get = ['$http', '$q', function($http, $q) {
      let cache;
      return function asyncYamlLoader(options) {
        if (!cache) {
          return $http.get(url).then(function(response) {
            cache = jsyaml.load(response.data);
            return cache;
          });
        } else {
          return $q.resolve(cache);
        }
      };
    }];
  });
})();